import { config } from "@/config/constants.js";
export default {
  data() {
    return {
      pageTitle: 'Mirror Views',
      apiData: ''
    };
  },
  mounted() {

  },
  async created() {
    if (this.$route && this.$route.query) {
      const mValue = this.$route.query.m;
      const sValue = this.$route.query.s;
      if (mValue) {
        try {
          const response = await fetch(`${config.api_url}mirror_views?m=${mValue}&s=${sValue}`);
          if (!response.ok) {
           console.log('Network response was not ok');
          }
          const data = await response.text();
          this.apiData = data;
        } catch (error) {
          console.log('Error fetching data from API:', error);
        }
      }
    }
  }
};
